import { render } from "./upg.vue?vue&type=template&id=6dffdd06"
import script from "./upg.vue?vue&type=script&lang=js"
export * from "./upg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__